import http from './http';

export type ChatUnifiedRole = 'student' | 'counselor' | 'parent';

/** Matches BE `meta.session_hints` (unified-participants). Same shape may appear as `session_hint` on each row. */
export type SessionHintPair = 'student_counselor' | 'student_parent' | 'parent_counselor';

export interface UnifiedSessionHint {
  conversation_id: string;
  pair: SessionHintPair;
  student_id?: number;
  counselor_id?: number;
  parent_id?: number;
  /** Present on some responses; peer in the DM from the viewer’s perspective. */
  peer_user_id?: number;
}

/** Each row in `students` / `counselors` / `parents` may include `session_hint` (same shape as `meta.session_hints[]`). */
export interface UnifiedParticipantsData {
  students: any[];
  counselors: any[];
  parents: any[];
  meta?: {
    from_ids_for_unread?: number[];
    session_hints?: UnifiedSessionHint[];
  };
}

/**
 * POST /api/chat/unified-participants — một lần gọi thay cho getPartner + getCurrentCounselor + getParents + …
 */
export async function fetchUnifiedParticipants(params: {
  role: ChatUnifiedRole;
  filter_student_id?: number | null;
}): Promise<UnifiedParticipantsData | null> {
  try {
    const res: any = await http.post('api/chat/unified-participants', {
      role: params.role,
      filter_student_id: params.filter_student_id ?? null,
    });
    const inner = res?.statusCode === 200 && res?.data != null ? res.data : res;
    if (!inner || typeof inner !== 'object') return null;
    return {
      students: Array.isArray(inner.students) ? inner.students : [],
      counselors: Array.isArray(inner.counselors) ? inner.counselors : [],
      parents: Array.isArray(inner.parents) ? inner.parents : [],
      meta: inner.meta,
    };
  } catch {
    return null;
  }
}

export function conversationIdToSessionId(conversationId: string): string {
  return conversationId.startsWith('session_') ? conversationId.replace(/^session_/, '') : conversationId;
}
